import { axios, fileAxios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    biometricosExpediente: [],
    biometricoToUpdate: null,
    personalBiometrico: '',
  },

  getters: {
    getBiometricosExpediente: (state) => state.biometricosExpediente,
    getPersonalBiometrico: (state) => state.personalBiometrico,
  },

  mutations: {
    SET_BIOMETRICOS_EXPEDIENTE(state, biometricosExpediente) {
      state.biometricosExpediente = biometricosExpediente;
    },

    SET_PERSONAL_BIOMETRICO(state, personalBiometrico) {
      state.personalBiometrico = personalBiometrico;
    },
  },

  actions: {
    async fetchBiometricosExpediente({ commit }, idExpediente) {
      await axios
        .get(`PoliciaCuadrantes/C3/expedientes/${idExpediente}/biometricos`)
        .then((response) => {
          commit('SET_BIOMETRICOS_EXPEDIENTE', response.data.data);
        });
    },

    async fetchTipoBiometrico() {
      await axios
        .get('PoliciaCuadrantes/EstadoFuerza/tipoBiometrico');
    },

    async saveBiometrico(context, biometrico) {
      await axios
        .post(`PoliciaCuadrantes/C3/expedientes/${biometrico.fk_idExpediente}/biometricos`, biometrico)
        .then((response) => {
          const formData = new FormData();
          formData.append('file', biometrico.file);
          formData.append('idBiometricos', response.data.data[0].ID);
          context.dispatch('uploadBiometrico', formData);
        });
    },

    async updateBiometrico(context, biometrico) {
      await axios
        .put(`PoliciaCuadrantes/C3/expedientes/${biometrico.fk_idExpediente}/biometricos`, biometrico)
        .then(() => {
          const formData = new FormData();
          formData.append('file', biometrico.file);
          formData.append('idBiometricoExpediente', biometrico.id);
          context.dispatch('uploadBiometrico', formData);
        });
    },

    async uploadBiometrico(context, formData) {
      await fileAxios
        .post('/C3/Biometrico/uploadFiles', formData)
        .then(() => {
          context.commit('SET_SNACKBAR_MESSAGE', 'Captura de biométrico guardada correctamente.', {
            root: true,
          });
        });
    },
  },
};
